var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 15.8748V14.4998H10.375C9.61738 14.4998 9 15.1171 9 15.8748V18.6248H18.9151C18.724 17.7846 18.625 16.8799 18.625 15.8748Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9436 21.3748C30.0059 22.8199 28.5759 24.0491 26.5271 25.2261C26.2122 25.4063 25.8575 25.4998 25.5 25.4998C25.1425 25.4998 24.7877 25.4063 24.477 25.2289C22.4282 24.0491 20.9983 22.8185 20.0591 21.3748H9V28.2498C9 29.0088 9.61738 29.6248 10.375 29.6248H29.625C30.384 29.6248 31 29.0088 31 28.2498V21.3748H30.9436ZM15.1875 25.4998H12.4375C12.058 25.4998 11.75 25.1918 11.75 24.8123C11.75 24.4328 12.058 24.1248 12.4375 24.1248H15.1875C15.567 24.1248 15.875 24.4328 15.875 24.8123C15.875 25.1918 15.567 25.4998 15.1875 25.4998Z",
    fill: "#4B9BF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5834 12.4934L25.7709 10.4309C25.5962 10.3567 25.4024 10.3567 25.2277 10.4309L20.4153 12.4934C20.1636 12.6007 20 12.8496 20 13.1246V15.8746C20 19.6572 21.3984 21.8682 25.1576 24.0338C25.2635 24.0943 25.3818 24.1246 25.5 24.1246C25.6182 24.1246 25.7365 24.0943 25.8424 24.0338C29.6016 21.8737 31 19.6627 31 15.8746V13.1246C31 12.8496 30.8364 12.6007 30.5834 12.4934ZM28.1001 15.6174L25.3501 19.0549C25.2181 19.2172 25.0201 19.3121 24.8125 19.3121C24.8029 19.3121 24.7919 19.3121 24.7836 19.3121C24.565 19.3024 24.3629 19.1897 24.2405 19.0068L22.8655 16.9443C22.6551 16.6281 22.7404 16.2018 23.0566 15.9914C23.3701 15.7824 23.7978 15.8649 24.0095 16.1826L24.8634 17.4627L27.0249 14.7594C27.2628 14.4638 27.6959 14.4171 27.9915 14.6522C28.2885 14.8873 28.3352 15.3204 28.1001 15.6174Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPayment);
export default __webpack_public_path__ + "static/media/noPayment.1fbdabb206a578ad6559a0f7142f844d.svg";
export { ForwardRef as ReactComponent };